import React, { useState } from "react"
import { CsvProduct } from "~/models/Product"
import { Api } from "~/api/Api"
import { Modal } from "react-bootstrap"
import { ButtonParts } from "~/components/atoms/ButtonParts"
import HtmlReactParser from "html-react-parser"

/*
    簡易版ヘルプボタンの生成用コンポーネント
    props
        data:csvProductデータ
 */

interface Props {
  data: CsvProduct
  name?: string
}

export function SimpleHelpButton(props: Props) {
  const { data, name } = props
  const [show, showSate] = useState<boolean>(false)
  const [element, setElement] = useState<string>("")

  const modalChange = async () => {
    if (!show) {
      const content = await Api.getHtmlData(name, "help")
      const dom = new DOMParser()
      const html = dom.parseFromString(content, "text/html").getElementsByClassName("modal-content")[0].innerHTML
      setElement(html)
    }
    showSate(!show)
  }
  return (
    <>
      <ButtonParts className="btn btn-sm ml-1 help-icon" action={modalChange} />
      <Modal className="introduction-support-modal" show={show} onHide={modalChange}
        size={`${(data.modalType || 1) === 1 ? "lg" : "xl"}`}>
        {HtmlReactParser(element)}
        <Modal.Footer>
          <ButtonParts className="btn btn-success" action={modalChange}>閉じる</ButtonParts>
        </Modal.Footer>
      </Modal>
    </>
  )
}
